var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubcard2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 46,
    viewBox: "0 0 131 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1_16374)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.641,
    cy: 23.2682,
    rx: 5.75928,
    ry: 4.62366,
    fill: "#E85C25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.641 19.1445C122.654 19.1447 124.9 21.0882 124.9 23.2686C124.9 25.4488 122.653 27.3914 119.641 27.3916C116.629 27.3916 114.382 25.4489 114.381 23.2686C114.381 21.088 116.628 19.1445 119.641 19.1445Z",
    stroke: "#E85C25"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.999512 45L9.63843 23.7312L19.4292 33.4409L25.1885 17.2581L35.5552 33.4409L51.1052 2L66.0793 23.7312L82.7812 17.2581L96.0276 27.8925L107.546 5.23656L116.185 17.2581L120.331 23.2688",
    stroke: "#E85C25",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_16374",
    x: 108.881,
    y: 13.6445,
    width: 21.5186,
    height: 19.248,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_16374"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubcard2);
export default __webpack_public_path__ + "static/media/subcard2.e2e90c2ab3c3e66e1aaa55bf4d45c05c.svg";
export { ForwardRef as ReactComponent };